import { Api } from 'utils';

class SanService {
		
	static admin = {
		getStates: async (params?: any) => Api.createResponse('admin/san/states',params),
		getCities: async (params?: any) => Api.createResponse('admin/san/cities',params),
		create: async (params?: any) => Api.createResponse('admin/san/create',params),
		update: async (params?: any) => Api.createResponse('admin/san/update',params),
		get: async (params?: any) => Api.createResponse('admin/san',params),
		delete: async (params?: any) => Api.createResponse('admin/san/delete',params),
		downloadChats: async (params?: any) => Api.createResponse('admin/san/download-chats',params),
		downloadAllChats: async (params?: any) => Api.createResponse('admin/san/download-all-chats',params),
	}

	static checkLink = async (params?: any) => Api.createResponse('app/client/san/check-link',params);

}

export default SanService;